import i18n from "i18next"
import localeDE from './de/translations.json'
import localeFR from './fr/translations.json'
import localeIT from './it/translations.json'
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';

export const resources = {
    de: {
        translation: localeDE
    },
    fr: {
        translation: localeFR
    },
    it: {
        translation: localeIT
    },
} as const;

i18n
    .use(detector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'de',
        cache: [],
        detection: {
            order: ['htmlTag']
        },
        resources,
    });

export default i18n
